import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../library/Button/Button';
import MenuBurgerIcon from './MenuBurgerIcon/MenuBurgerIcon';
import styles from './Navigation.module.css';
import { domains } from '../../global';
import type { ConfigState } from 'services/store/features/Config/types';

interface Props {
  auth: boolean;
  config: ConfigState;
};

export default function Navigation({
  auth, config,
}: Props) {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className={styles.navigation}>
      <div className={styles.section}>
        <Button
          className={styles.logo}
          variant="ghost"
          type="link"
          label="AYOMI"
          onButtonClick={() => document.location.assign(domains.website)}
        />
        {
          !auth ? (
            <>
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.solution')}
                onButtonClick={() => document.location.assign(`${domains.website}/solution`)}
              />
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.customers')}
                onButtonClick={() => document.location.assign(`${domains.website}/clients`)}
              />
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.contact')}
                onButtonClick={() => document.location.assign(`${domains.website}/contact`)}
              />
            </>
          ) : <></>
        }
      </div>
      <div className={styles.section}>
        {
          !auth ? (
            <Button
              className={styles.split}
              variant="ghost"
              type="link"
              label={t('navigation.login')}
              onButtonClick={() => document.location.assign(`${domains.auth}?redirect=${window.location.href}`)}
            />
          ) : <></>
        }
        <Button
          variant="fill"
          type="primary"
          label={t('navigation.takeRdv')}
          onButtonClick={() => window.open(config.calendly)}
        />
      </div>
      <div className={styles.navigationMobile}>
        <div className={styles.sectionMobile}>
          <Button
            className={styles.logo}
            variant="ghost"
            type="link"
            label="AYOMI"
            onButtonClick={() => document.location.assign(domains.website)}
          />
        </div>
        <div className={styles.sectionMobile}>
          {
            auth ? (
              <Button
                variant="fill"
                type="primary"
                label={t('navigation.takeRdv')}
                onButtonClick={() => window.open(config.calendly)}
              />
            ) : (
              <Button
                className={styles.buttonBurger}
                variant="ghost"
                type="link"
                label=""
                icon={<MenuBurgerIcon isOpen={isMenuOpen} />}
                onButtonClick={() => setIsMenuOpen(!isMenuOpen)}
              />
            )
          }
        </div>
      </div>
      {
        (isMenuOpen) && (
          <div className={styles.navigationMenuMobile}>
            <Button
              className={styles.split}
              variant="ghost"
              type="link"
              label={t('navigation.login')}
              onButtonClick={() => document.location.assign(`${domains.auth}?redirect=${window.location.href}`)}
            />
            <Button
              variant="fill"
              type="primary"
              label={t('navigation.takeRdv')}
              onButtonClick={() => window.open(config.calendly)}
            />
          </div>
        )
      }
      <div className={`${styles.navigationMenuMobile} ${styles.navigationBackGround}`}>
        {
          !auth ? (
            <>
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.solution')}
                onButtonClick={() => document.location.assign(`${domains.website}/solution`)}
              />
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.customers')}
                onButtonClick={() => document.location.assign(`${domains.website}/clients`)}
              />
              <Button
                variant="ghost"
                type="link"
                label={t('navigation.contact')}
                onButtonClick={() => document.location.assign(`${domains.website}/contact`)}
              />
            </>
          ) : <></>
        }
      </div>
    </nav>
  );
}
